// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__Ep787","emails":"CreateEditClinics_emails__2hjeq","emailTagLabel":"CreateEditClinics_emailTagLabel__3EKAq"};